'use client';

import { useEffect, useRef, useState } from 'react';

/** `html` is already the shop's allow-list (`shopDescriptionHtml` from `@unur/formats`). */
export function CollapsibleDescription({ html }: { html: string }) {
  const [expanded, setExpanded] = useState(false);
  const [overflows, setOverflows] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const check = () => {
      if (!expanded) {
        const innerDiv = el.firstElementChild;
        if (innerDiv && innerDiv.children.length > 1) {
          setOverflows(true);
        } else {
          setOverflows(el.scrollHeight > el.clientHeight);
        }
      }
    };
    check();

    const observer = new ResizeObserver(() => check());
    observer.observe(el);

    return () => observer.disconnect();
  }, [html, expanded]);

  return (
    <div className="mt-3">
      <div
        ref={ref}
        className={`text-sm leading-relaxed text-contrast-400 [&_a]:font-normal [&_a]:text-accent-dark [&_a]:underline [&_a]:underline-offset-2 [&_p+p]:mt-4 ${
          !expanded ? 'max-h-[3.25em] overflow-hidden [&>div>*+*]:hidden' : ''
        }`}
      >
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </div>
      {overflows && (
        <button
          className="mt-1 text-sm text-accent-primary underline underline-offset-2"
          onClick={() => setExpanded(!expanded)}
          type="button"
        >
          {expanded ? 'Read less' : '… Read more'}
        </button>
      )}
    </div>
  );
}
